import About from "../Sections/about/About";
import Jumbotron from "../Sections/about/Jumbotron";
import Testimonial from "../Sections/about/Testimonial";
import Team from "../Sections/about/Team";
import { useGetSettingQuery } from "../../../Redux/Apis/siteApi";

function AboutUs() {
    const { data: {about} } = useGetSettingQuery()

    return ( 
        <>
        {about.jumbotron && <Jumbotron/>}
        {about.about && <About/>}
        {about.team && <Team/>}
        {about.testimonial && <Testimonial/>}
        </>
    );
}

export default AboutUs;